// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"524":"app","884":"admin"}[chunkId] || chunkId) + "." + {"207":"027c82378ec43036a205","345":"73e7261efe851656ffde","524":"5921fa26073f9abc62ff","532":"1583376bfc28baf03f65","671":"d9cc5aa3258c6b39d38e","708":"57be1c1794147b88065a","884":"96f4fa481c16fd02e041","912":"d0f2dbd46306ef8fa1e1"}[chunkId] + ".js";
};